import { useMemo } from "react";
import {
  useParams,
  useSearchParams as useSearchParamsRouter
} from "react-router-dom";

export const useSearchParams = () => {
  const params = useParams();
  const [searchParams] = useSearchParamsRouter();

  const searchParamsObject = useMemo(() => {
    return Array.from(searchParams.keys()).reduce(
      (acc, key) => {
        acc[key] = searchParams.get(key) ?? null;
        return acc;
      },
      {} as Record<string, string | null>
    );
  }, [searchParams]);

  return {
    ...(params ?? {}),
    ...searchParamsObject
  };
};
